






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Picker from '@simonwep/pickr';
import '@simonwep/pickr/dist/themes/monolith.min.css';

@Component({
    components: {}
})
export default class CFormColorPicker extends Vue {
    @Prop({
        type: String,
        default: '#ccc'
    })
    value!: string;

    $refs!: {
        el: HTMLDivElement;
    };

    pickr: any = {};

    @Watch('value')
    valueChange() {
        this.pickr.setColor(this.value);
    }

    mounted() {
        this.pickr = Picker.create({
            el: this.$refs.el,
            theme: 'monolith',
            defaultRepresentation: 'RGBA',
            default: this.value,
            showAlways: true,
            container: this.$refs.el.parentElement ?? 'body',
            components: {
                // Main components
                preview: true,
                opacity: true,
                hue: true,
                // Input / output Options
                interaction: {
                    hex: false,
                    rgba: true,
                    hsla: false,
                    hsva: false,
                    cmyk: false,
                    input: true,
                    clear: false,
                    save: true
                }
            }
        });

        this.pickr.on('change', (e: any) => {
            const [r, g, b, a] = e.toRGBA();
            this.$emit('color-picked', {
                value: `rgba(${Math.ceil(r)},${Math.ceil(g)},${Math.ceil(
                    b
                )},${parseFloat(a).toFixed(2)})`
            });
        });
        this.pickr.on('save', (e: any) => {
            this.$emit('color-picked', {
                value: this.value
            });
        });
    }
}
